class AddColumnController {

    constructor($scope, $uibModalInstance, headings, Notification, EVENTS) {

        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.Notification = Notification;
        this.$scope.headings = headings
        this.EVENTS = EVENTS;
        this.$scope.name = "";

        this.$scope.allDefaultFields = [
            { key: "@adserver", value: "Ad Server"},
            { key: "FALLBACK_IMPRESSION", value: "Fallback Impression"},
            { key: "IMPRESSION", value: "Impression"},
            { key: "OUTLINK", value: "OUTLINK"},
        ];

        this.$scope.typeAheadFields = [];

        this.$scope.allDefaultFields.forEach( val => {
            if(headings.rawHeadings.indexOf(val.key) == -1) {
                this.$scope.typeAheadFields.push(val);
            }
        });

        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);

    }

    ok() {

        if(typeof this.$scope.name !== "object") {
            this.$scope.name = {key: this.$scope.name, value: this.$scope.name };
        }

        if(this.$scope.headings.rawHeadings.indexOf(this.$scope.name.key)  == -1 && this.$scope.headings.formattedHeadings.indexOf(this.$scope.name.value)  == -1) {
            this.$uibModalInstance.close(this.$scope.name);
        }
        else {
            this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "A heading with the name '" + this.$scope.name.value + "' already exists.", 'messageType': 'error'});
        }

    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

angular.module("cpm").controller("AddColumnController", ['$scope', '$uibModalInstance', 'headings', 'Notification', 'EVENTS', AddColumnController]);
